<template>
  <v-layout
    v-if="items.length > 0"
    column
  >
    <v-tabs>
      <v-tab style="text-transform: none">
        <h2 class="subheading font-weight-bold">
          Уведомления
        </h2>
      </v-tab>
      <v-tab style="text-transform: none">
        <h2 class="subheading font-weight-bold">
          Сообщения из Кабинета
        </h2>
      </v-tab>
      <v-tab-item>
        <v-layout
          align-center
          justify-end
        >
          <div>
            <v-switch
              v-model="isUnread"
              label="Только непрочитанные"
              class="my-0 mx-2"
              hide-details
              :disabled="!unreadNotifications"
            />
          </div>
        </v-layout>
        <v-layout
          style="height: 260px; overflow-y: auto"
          @scroll="onScroll"
        >
          <v-list three-line>
            <template v-for="notification in notifications">
              <v-subheader
                :key="notification.id"
                :class="{
                  'font-weight-bold': !notification.isReaded,
                  'my-2':
                    notification.message && notification.message.length > 40,
                }"
                style="min-height: 35px; height: auto"
              >
                <v-layout column>
                  <v-flex>
                    <v-layout>
                      <span class="subheading primary--text">{{
                        getNotificationTitle(notification.type)
                      }}</span>
                      <v-chip
                        small
                        class="mx-1 my-0"
                      >
                        {{ notification.date | dateTime }}
                      </v-chip>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout>
                      <v-flex xs11>
                        <v-layout column>
                          <!-- <v-flex v-if="notification.payload">
                            <span
                              class="text-uppercase grey--text text--darken-4 font-weight-medium"
                              >Маршрут:
                            </span>
                            <span class="text-uppercase primary--text">
                              <LinkCell
                                v-if="notification.payload.route"
                                :id="notification.payload.route.id"
                                :text="notification.payload.route.title"
                                resource="routes"
                              />
                            </span>
                          </v-flex> -->
                          <v-flex v-if="notification.payload">
                            <span
                              class="text-uppercase grey--text text--darken-4 font-weight-medium"
                            >Поставка:
                            </span>
                            <span class="text-uppercase primary--text">
                              <LinkCell
                                v-if="notification.payload.shipping"
                                :id="notification.payload.shipping.id"
                                :text="notification.payload.shipping.title"
                                resource="shippings"
                              />
                            </span>
                          </v-flex>
                          <v-flex v-if="notification.payload">
                            <NotificationsImages
                              v-if="notification.type === 4"
                              :images="notification.payload.files"
                              :scroll-value="scrollValue"
                            />

                            <NotificationsFiles
                              v-if="notification.type === 5"
                              :files="notification.payload.files"
                              :scroll-value="scrollValue"
                            />
                          </v-flex>

                          <v-flex>
                            <span>{{ notification.message }}</span>
                          </v-flex>

                          <v-flex v-if="notification.payload.client">
                            <span
                              class="grey--text text--darken-4 font-weight-medium"
                            >
                              Клиент:
                            </span>
                            <span class="text-uppercase">{{
                              notification.payload.client.title
                                ? notification.payload.client.title
                                : ""
                            }}</span>
                          </v-flex>

                          <v-flex v-if="notification.payload">
                            <span
                              class="grey--text text--darken-4 font-weight-medium"
                            >Продавец:
                            </span>
                            <span class="text-uppercase">{{
                              notification.payload.sender
                                ? notification.payload.sender
                                : ""
                            }}</span>
                          </v-flex>
                          <!-- <v-flex v-if="notification.payload">
                            <span
                              class="grey--text text--darken-4 font-weight-medium"
                              >Водитель:
                            </span>
                            <span class="text-uppercase">{{
                              notification.payload.driver
                                ? notification.payload.driver.title
                                : ""
                            }}</span>
                          </v-flex>
                          <v-flex v-if="notification.payload">
                            <span
                              class="grey--text text--darken-4 font-weight-medium"
                              >Моб.номер.Viber:
                            </span>
                            <span v-if="notification.payload.driver">{{
                              notification.payload.driver.viber
                                | phoneInternational
                            }}</span>
                          </v-flex>
                          <v-flex v-if="notification.payload">
                            <span
                              class="grey--text text--darken-4 font-weight-medium"
                              >Моб.номер:
                            </span>
                            <span v-if="notification.payload.driver">{{
                              notification.payload.driver.phones
                                | phoneInternational
                            }}</span>
                          </v-flex> -->
                        </v-layout>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-checkbox
                              v-model="notification.isReaded"
                              :false-value="false"
                              :true-value="true"
                              class="ma-0 pa-0"
                              hide-details
                              v-on="on"
                              @change="changeNotificationStatus(notification)"
                            />
                          </template>
                          <span>{{
                            notification.isReaded
                              ? "Пометить как непрочитанное"
                              : "Пометить как прочитанное"
                          }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-subheader>
            </template>
          </v-list>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <v-layout
          align-center
          justify-end
        >
          <div>
            <v-switch
              v-model="isUnreadCabClientNotifications"
              label="Только непрочитанные"
              class="my-1 mx-2"
              hide-details
              :disabled="!unreadCabClientNotifications"
            />
          </div>
        </v-layout>
        <v-layout
          style="height: 260px; overflow-y: auto"
          @scroll="onScroll"
        >
          <v-list three-line>
            <template v-for="notification in cabClientNotifications">
              <v-subheader
                :key="notification.id"
                :class="{
                  'font-weight-bold': !notification.isReaded,
                  'my-2':
                    notification.message && notification.message.length > 40,
                }"
                style="min-height: 35px; height: auto"
              >
                <v-layout column>
                  <v-flex>
                    <v-chip
                      small
                      class="mx-1 my-0"
                    >
                      {{ notification.date | dateTime }}
                    </v-chip>
                  </v-flex>
                  <v-flex>
                    <v-layout>
                      <v-flex xs11>
                        <v-layout column>
                          <v-flex v-if="notification.payload">
                            <span
                              class="text-uppercase grey--text text--darken-4 font-weight-medium"
                            >Поставка:
                            </span>
                            <span class="text-uppercase primary--text">
                              <LinkCell
                                v-if="notification.payload.shipping"
                                :id="notification.payload.shipping.id"
                                :text="notification.payload.shipping.title"
                                resource="shippings"
                              />
                            </span>
                          </v-flex>
                          <v-flex>
                            <span>{{ notification.message }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs1>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-checkbox
                              v-model="notification.isReaded"
                              :false-value="false"
                              :true-value="true"
                              class="ma-0 pa-0"
                              hide-details
                              v-on="on"
                              @change="changeNotificationStatus(notification)"
                            />
                          </template>
                          <span>{{
                            notification.isReaded
                              ? "Пометить как непрочитанное"
                              : "Пометить как прочитанное"
                          }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-subheader>
            </template>
          </v-list>
        </v-layout>
        <v-layout
          align-center
          justify-end
        >
          <span
            class="my-1 mx-2 grey--text text-xs-right"
          >Сообщения за последние 30 дней</span>
        </v-layout>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>
<script>
import LinkCell from "../../components/LinkCell.vue";
import { notificationTypes } from "../../enums/notification-types.js";
import NotificationsImages from "./NotificationsImages.vue";
import NotificationsFiles from "./NotificationsFiles.vue";
export default {
  components: {
    LinkCell,
    NotificationsImages,
    NotificationsFiles,
  },
  props: ["items"],
  data() {
    return {
      isUnread: false,
      isUnreadCabClientNotifications: false,
      notifications: [],
      cabClientNotifications: [],
      imgMenu: false,
      scrollValue: 0,
    };
  },
  computed: {
    unreadNotifications() {
      if (!this.items || this.items.length === 0) return false;

      const targetItems = this.items.filter(
        (v) => v.type !== notificationTypes.ShippingMessageFromCabinetClient.id
      );

      return targetItems.some((n) => !n.isReaded);
    },
    unreadCabClientNotifications() {
      if (!this.items || this.items.length === 0) return false;

      const targetItems = this.items.filter(
        (v) => v.type === notificationTypes.ShippingMessageFromCabinetClient.id
      );

      return targetItems.some((n) => !n.isReaded);
    },
  },
  watch: {
    items: {
      handler(value) {
        this.notifications = value.filter(
          (v) =>
            v.type !== notificationTypes.ShippingMessageFromCabinetClient.id
        );
        this.cabClientNotifications = value.filter(
          (v) =>
            v.type === notificationTypes.ShippingMessageFromCabinetClient.id
        );
        if (!value.filter((n) => !n.isReaded).length) {
          this.isUnread = false;
        }
      },
      immediate: true,
      deep: true,
    },
    isUnread(value) {
      if (value) {
        this.notifications = [
          ...new Set(
            this.items.filter(
              (i) =>
                i.type !== notificationTypes.ShippingMessageFromCabinetClient.id
            )
          ),
        ].filter((n) => !n.isReaded);
      } else {
        this.notifications = [
          ...new Set(
            this.items.filter(
              (i) =>
                i.type !== notificationTypes.ShippingMessageFromCabinetClient.id
            )
          ),
        ];
      }
    },
    isUnreadCabClientNotifications(value) {
      if (value) {
        this.cabClientNotifications = [
          ...new Set(
            this.items.filter(
              (i) =>
                i.type === notificationTypes.ShippingMessageFromCabinetClient.id
            )
          ),
        ].filter((n) => !n.isReaded);
      } else {
        this.cabClientNotifications = [
          ...new Set(
            this.items.filter(
              (i) =>
                i.type === notificationTypes.ShippingMessageFromCabinetClient.id
            )
          ),
        ];
      }
    },
  },
  methods: {
    getNotificationTitle(type) {
      switch (type) {
        case notificationTypes.ShippingSplitted.id:
          return notificationTypes.ShippingSplitted.title;
        case notificationTypes.ShippingDamage.id:
          return notificationTypes.ShippingDamage.title;
        default:
          return "";
      }
    },
    changeNotificationStatus(notification) {
      this.$emit("change", notification);
    },
    onScroll(e) {
      this.scrollValue = e.target.scrollTop;
    },
  },
};
</script>
